var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg017Safety = function Svg017Safety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 271c19.367 0 35.768-12.363 42.1-29.559-24.278-21.088-40.296-51.475-41.633-85.822C93.981 182.355 61.392 222.997 44.306 271zM376 271h91.694c-17.086-48.003-49.675-88.645-92.161-115.38-1.337 34.347-17.353 64.733-41.633 85.822C340.232 258.637 356.633 271 376 271M31 346v15h450v-15c0-15.474-2.012-30.416-4.995-45H376c-29.764 0-55.313-17.563-67.421-42.751C292.656 266.14 274.979 271 256 271s-36.656-4.86-52.579-12.751C191.312 283.437 165.764 301 136 301H35.995C33.012 315.584 31 330.526 31 346M0 391h512v60H0zM256 61c-49.706 0-90 40.294-90 90s40.294 90 90 90 90-40.294 90-90-40.294-90-90-90m0 135c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 151,
    r: 15
  })));
};
export default Svg017Safety;